import { Injectable, inject } from '@angular/core';
import { IListDataProvider, MdbService } from '@luzula/luzula-lib';
import { DataService } from '../data.service';

/**
 * Implementierung von IListDataProvider für die App.
 * Verwendet DataService für hardcodierte Daten und MdbService für JSON-Tabellen.
 */
@Injectable({ providedIn: 'root' })
export class ListDataProvider implements IListDataProvider {
	private ds = inject(DataService);
	private mdb = inject(MdbService);

	getHardcoded(tableName: string): any[] {
		return this.ds.getHardcoded(tableName);
	}

	getTable(tableName: string): any[] {
		// Single Source: im ListStore registrierte Tabellen (auch ehemalige
		// dietmarsMdb-Tabellen) kommen aus dem Store statt per HTTP.
		if (this.ds.isListKnown(tableName)) {
			return this.ds.getHardcoded(tableName);
		}
		// Sonst: MdbService (leeres Array, wenn noch nicht geladen; Laden läuft im Hintergrund)
		return this.mdb.getTable(tableName) ?? [];
	}

	async getTableAsync(tableName: string): Promise<any[]> {
		if (this.ds.isListKnown(tableName)) {
			return this.ds.getHardcoded(tableName);
		}
		return this.mdb.getTableAsync(tableName);
	}
}
